import React, { useEffect, useState } from 'react';
import { Card, Modal } from 'antd';
import { useParams } from 'react-router-dom';
import { useOrder } from '../store/orderContext';
import OrderList from '../components/Order/OrderList';
import OrderForm from '../components/Order/OrderForm';
import { Order } from '../types/order';
import { useTranslation } from 'react-i18next';

const OrderStatusPage: React.FC = () => {
    const { status } = useParams();
    const { fetchOrdersByStatus, updateOrder } = useOrder();
    const [editOrder, setEditOrder] = useState<Order | undefined>();
    const [modalVisible, setModalVisible] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (status) fetchOrdersByStatus(status as any);
    }, [status]);

    const handleEdit = (order: Order) => {
        setEditOrder(order);
        setModalVisible(true);
    };

    const handleSubmit = (order: Order) => {
        updateOrder(order);
        setModalVisible(false);
        setEditOrder(undefined);
    };

    return (
        <>
          <Card title={`${t('orders')} - ${t(status || '')}`}>
              <OrderList onEdit={handleEdit} />
          </Card>

          <Modal
              title={t('edit_order')}
              open={modalVisible}
              footer={null}
              onCancel={() => {
                  setModalVisible(false);
                  setEditOrder(undefined);
              }}
              width={900}
          >
              <OrderForm
                  editOrder={editOrder}
                  onFinishEdit={() => {
                      setModalVisible(false);
                      setEditOrder(undefined);
                  }}
                  onSubmit={handleSubmit}
              />
          </Modal>
      </>
  );
};

export default OrderStatusPage;
